import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import FileUploadService from '../../services/FileUploadService';
import SettingService from '../../services/SettingService';
import UserTransportService from '../../services/UserTransportService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import UserTransportDetailsResponse from './UserTransportDetailsResponse';
import Constants from '../../utils/constants';
import {Panel} from 'primereact/panel';
import StringUtils from '../../utils/StringUtils';
import YesNoDialog from '../../components/YesNoDialog';
import DataTableLazy, {mounted} from '../../components/DataTableLazy';
import InternalUserService from '../../services/MobileUserService';
import TransportService from '../../services/TransportService';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import moment from 'moment';
import DateUtils from '../../utils/DateUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';
import MapWithRouteV2 from '../../components/base/MapWithRouteV2';
import MapLibreUtils from '../../utils/MaplibreUtils';
import CompanyTransportService from '../../services/CompanyTransportService';

class UserTransportContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new UserTransportService());
        this.fileUploadService = new FileUploadService();
        this.companyTransportService = new CompanyTransportService();
        this.state = {
            showConfirmExcludeTransport: false,
            showConfirmIncludeTransport: false,
            showConfirmIRejectIncludeTransport: false,
            viewMode: props.viewMode,
            loading: true,
            elementId: props.elementId,
            usersPageable: undefined,
            transportPageable: undefined,
            locale: props.locale,
            globalLocale: props.locale,
            supportedLocales: [],
            route: [],
            directions: [
                {
                    label: t('DirectionType.FROM_WORK'),
                    value: 'FROM_WORK',
                },
                {
                    label: t('DirectionType.TO_WORK'),
                    value: 'TO_WORK',
                },
                {
                    label: t('DirectionType.UNSET'),
                    value: 'UNSET',
                },
            ],
            element: {
                translations: [],
                includeDirection: null,
            },
            circleCenter: [54.312795, 18.651946],
            zoom: 10,
            initialCoordinates: {
                lat: Constants.initialLatitude,
                lng: Constants.initialLongitude,
            },
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.mobileUserService = new InternalUserService();
        this.transportService = new TransportService();
        this.editorRef = React.createRef();
        this.transportsTable = React.createRef();
        this.usersTable = React.createRef();
    }

    componentDidMount() {
        super.componentDidMount();
        console.log('[UserTransportContainer] componentDidMount');
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    componentWillUnmount() {
        this.unMountDatatableLazyComponent();
        super.componentWillUnmount();
    }
    unMountDatatableLazyComponent = () => {
        mounted.length = 0;
    };
    prepareElementBeforeRequest(element) {
        if (element.direction === 'UNSET') {
            element.direction = undefined;
        }
        return element;
    }
    updateElement(data) {
        this.setState((prevState) =>(
            {
                ...prevState,
                element: UserTransportDetailsResponse.copy(this.state.element, data, this.state.globalLocale),                
            }),
            () => {
                console.log('[UserTransportContainer] updated state.element:', this.state.element);
                this.mapRoute();
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        const {viewMode, locale} = this.props;
        const {elementId} = this.state;

        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            console.log('[UserTransportContainer] setElement start, elementId:', elementId);
            this.service
                .get(elementId, locale)
                .then((data) => {
                    console.log('[UserTransportContainer] received from API:', data);
                    this.setState((prevState) => ({
                        ...prevState,
                        loading: false}), () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState((prevState) => ({
                ...prevState,
                loading: false}), this.initAfterSetElement);
        }
    }
    initBeforeSetElement() {
        const {viewMode} = this.props;
        this.getUserList(this.getUserCleanSearchCriteria());
        this.getTransportList(this.getTransportCleanSearchCriteria());
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState((prevState) => ({
                    ...prevState,
                    supportedLocales,
                    // Do not overwrite details loaded from API in VIEW/EDIT mode.
                    // This async call can resolve after `setElement`, causing occasional blank fields.
                    element:
                        viewMode === 'NEW'
                            ? new UserTransportDetailsResponse(supportedLocales, this.props.locale)
                            : prevState.element,
                }));
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });
    }

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [ {
            label: t('global.back'),
            // href: AppPrefixUtils.locationHrefUrl(backUrl),
            onClick: () => {
                this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
            },
            className: 'gray float-right',
            rendered: true,
        },];
    }

    canModifyTransportRewards() {
        return this.isUserInRole('ROLE_MODIFY_USER_TRANSPORT');
    }

    getRewardsFieldViewMode() {
        if (this.props.viewMode === 'NEW') {
            return this.viewMode();
        }
        return this.canModifyTransportRewards() ? 'EDIT' : 'VIEW';
    }

    prepareFooterItems() {
        const {detailUrl, locale} = this.props;
        const viewMode = this.props.viewMode;
        const detailHref = `${detailUrl}/${this.props.elementId}/${locale}`;
        return [
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'EDIT',
            },

            {
                label: t('global.exclude'),
                onClick: this.handleShowConfirmExcludeDialog.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: viewMode === 'VIEW' && this.state.element.workRelated,
            },
            {
                label: t('global.include'),
                onClick: this.handleShowConfirmIncludeDialog.bind(this),
                className: 'float-right',
                iconName: 'mdi-plus-circle',
                rendered: viewMode === 'VIEW' && !this.state.element.workRelated,
            },
            {
                label: t('global.reject_include'),
                onClick: this.handleShowConfirmRejectIncludeDialog.bind(this),
                className: 'float-right',
                iconName: 'mdi-cancel',
                rendered: viewMode === 'VIEW' && !this.state.element.workRelated &&  this.state.element.userRequestedInclude,
            },
            {
                label: t('global.save'),
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW',
                id: 'addNewTransportBtn'
            },
            {
                label: t('global.save'),
                onClick: this.handleSaveRewards,
                rendered: viewMode === 'VIEW' && this.canModifyTransportRewards(),
                className: 'float-right',
            },
        ];
    }
    calculateAverageSpeed = (callBack) => {
        const {finishTravelDate, startTravelDate, totalDistanceTraveledKilometer} = this.state.element;
        if (!finishTravelDate || !startTravelDate || StringUtils.isBlank(totalDistanceTraveledKilometer)) {
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    averageSpeed: undefined,
                },
            }));
            return;
        }
        const timeDiff = Math.abs(finishTravelDate.getTime() - startTravelDate.getTime());
        const diffInMinutes = Math.floor(timeDiff / (1000 * 60));
        const diffInHours = (diffInMinutes / 60).toFixed(2);
        const averageSpeed = (totalDistanceTraveledKilometer / diffInHours).toFixed(2);
        this.setState(
            (prevState) => ({
                element: {
                    ...prevState.element,
                    averageSpeed,
                },
            }),
            () => {
                if (callBack) {
                    callBack();
                }
            }
        );
    };
    calculateSavedCo2 = () => {
        const {transport, totalDistanceTraveledKilometer} = this.state.element;
        if (!transport?.multiplier || StringUtils.isBlank(totalDistanceTraveledKilometer)) {
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    savedCo2Gram: undefined,
                },
            }));
            return;
        }
        const multiplier = transport.multiplier;
        const totalMeters = parseInt(totalDistanceTraveledKilometer) * 1000;
        const savedCo2Gram = parseInt((totalMeters * multiplier) / 1000);
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                savedCo2Gram,
            },
        }));
    };
    calculateBurnedCalories = () => {
        const {finishTravelDate, startTravelDate, user, transport, averageSpeed} = this.state.element;
        if (!finishTravelDate || !startTravelDate || !user?.id || !transport?.id) {
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    burnedCalories: undefined,
                },
            }));
            return;
        }
        const timeDiff = Math.abs(finishTravelDate.getTime() - startTravelDate.getTime());
        const diffInMinutes = Math.floor(timeDiff / (1000 * 60));
        const diffInHours = (diffInMinutes / 60).toFixed(2);
        let foundedMet = transport.mets.find((met) => {
            return averageSpeed <= met.speedRangeTo && averageSpeed >= met.speedRangeFrom;
        });
        let minDiff = Number.POSITIVE_INFINITY;
        if (!foundedMet) {
            transport.mets.forEach((met) => {
                let diff = Math.abs(averageSpeed - (met.speedRangeTo + met.speedRangeFrom) / 2);
                if (diff < minDiff) {
                    foundedMet = met;
                    minDiff = diff;
                }
            });
        }
        const met = foundedMet?.met ? foundedMet?.met : 15;
        const burnedCalories = (met * user.weight * diffInHours).toFixed(2);
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                burnedCalories,
            },
        }));
    };

    calculateTotalCoins() {
        const {totalDistanceTraveledKilometer, transport} = this.state.element;

        if (!transport || transport.id == null) {
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    totalEarnedCoins: undefined,
                },
            }));
            return;
        }

        const ppk = Number(transport.pointsPerKilometer);
        const ppa = Number(transport.pointsPerActivity);
        const safePpk = Number.isFinite(ppk) ? ppk : 0;
        const safePpa = Number.isFinite(ppa) ? ppa : 0;

        let km = 0;
        if (!StringUtils.isBlank(totalDistanceTraveledKilometer)) {
            const parsed = parseFloat(totalDistanceTraveledKilometer);
            if (Number.isFinite(parsed)) {
                km = parsed;
            }
        }

        const total = km * safePpk + safePpa;
        const rounded = Math.round(total * 1000) / 1000;

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                totalEarnedCoins: rounded,
            },
        }));
    }

    handleShowConfirmExcludeDialog(e) {
        e.preventDefault();
        this.setState((prevState) => ({
            ...prevState,
            showConfirmExcludeTransport: true,
        }));
    }

    handleShowConfirmIncludeDialog(e) {
        e.preventDefault();
        this.setState((prevState) => ({
            ...prevState,
            showConfirmIncludeTransport: true,
        }));
    }

    handleShowConfirmRejectIncludeDialog(e) {
        e.preventDefault();
        this.setState((prevState) => ({
            ...prevState,
            showConfirmIRejectIncludeTransport: true,
        }));
    }

    onExcludeAction(callback) {
        this.blockUi();
        this.service
            .exclude(this.state.elementId)
            .then(() => {
                callback();
                this.setElement();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.setState((prevState) => ({
                    ...prevState,
                    showConfirmExcludeTransport: false})
                );
            });
    }
    onIncludeAction(callback) {
        this.blockUi();
        this.service
            .include(this.state.elementId, this.state.element.includeDirection )
            .then(() => {
                callback();
                this.setElement();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.setState((prevState) => ({
                    ...prevState,
                    showConfirmIncludeTransport: false})
                );
            });
    }
    onIncludeRejectAction(callback) {
        this.blockUi();
        this.service
            .rejectInclude(this.state.elementId)
            .then(() => {
                callback();
                this.setElement();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.setState((prevState) => ({
                    ...prevState,
                    showConfirmIRejectIncludeTransport: false})
                );
            });
    }
    goBackUrl() {
        const {backUrl} = this.props;
        return backUrl;
    }
    viewMode() {
        if (this.props.viewMode === 'EDIT') {
            return 'VIEW';
        } else {
            return this.props.viewMode;
        }
    }

    getContainerListName() {
        return 'user-transport-list-container';
    }
    handleSaveRewards = () => {
        if (!this.canModifyTransportRewards()) {
            this.showErrorMessage(t('user-transport.rewards.save.error'));
            return;
        }
        const {element, elementId} = this.state;
        const savedCo2Gram = element?.savedCo2Gram;
        const totalEarnedCoins = element?.totalEarnedCoins;
        if (savedCo2Gram === undefined || savedCo2Gram === null || savedCo2Gram < 0) {
            this.showErrorMessage(t('user-transport.rewards.validation.co2'));
            return;
        }
        if (totalEarnedCoins === undefined || totalEarnedCoins === null || totalEarnedCoins < 0) {
            this.showErrorMessage(t('user-transport.rewards.validation.points'));
            return;
        }
        this.blockUi();
        this.service
            .updateRewards(elementId, {savedCo2Gram, totalEarnedCoins})
            .then(() => {
                this.showSuccessMessage(t('user-transport.rewards.save.success'));
                this.setElement();
            })
            .catch((err) => {
                this.showErrorMessage(err?.message || t('user-transport.rewards.save.error'));
            })
            .finally(() => this.unblockUi());
    };

    createOrUpdate() {
        const {element} = this.state;
        const request = this.prepareElementBeforeRequest(element);
        this.scrollToTop();
        if (this._isMounted) {
            if (element.id === undefined || element.id === null) {
                if (element.user?.id === undefined) {
                    this.showErrorMessage(t('user-transport.validation.user'));
                    this.unblockUi();
                    return;
                }
                if (element.transport?.id === undefined) {
                    this.showErrorMessage(t('user-transport.validation.activity'));
                    this.unblockUi();
                    return;
                }
                if (request?.averageSpeed === 'Infinity') {
                    this.showErrorMessage(t('user-transport.validation.time'));
                    this.unblockUi();
                    return;
                }
                this.service
                    .saveFake(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((ex) => {
                        this.showErrorMessage(t('user-transport.validation..save'));
                        this.unblockUi();
                    });
            }
        }
    }

    changeLocalLanguage(a, b, c) {
        const {editUrl} = this.props;
        const {elementId} = this.state;
        const locale = c.value;
        // window.location.href = AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale));
    }

    renderlocaleuages = () => {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state.locale}
                options={this.state.supportedLocales}
                insideTable
                viewMode={'EDIT'}
                onChange={this.handleChange}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    };

    getBackLabel() {
        return t('global.backToList');
    }

    getPassengerAvatarPath(avatarUuid) {
        if (StringUtils.isBlank(avatarUuid)) {
            return null;
        }
        return `${this.mobileUserService.getPath()}/${avatarUuid}/avatar/current-user?token=${this.authService.getToken()}`;
    }

    getPassengerInitials(fullName) {
        if (StringUtils.isBlank(fullName)) {
            return '?';
        }
        const parts = fullName.trim().split(' ').filter(Boolean);
        if (parts.length === 1) {
            return parts[0].substring(0, 1).toUpperCase();
        }
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }

    render() {
        console.log('[UserTransportContainer] render');
        return <div className='container-fluid'>{this.renderView()}</div>;
    }

    breadCrumbItems() {
        return [
            {name: t('user-transport.listName'), url: '/user-transport-list'},
            {name: t('user-transport.details'), url: ``},
        ];
    }
    handleMarkerDrag(coordinates, markerIndex) {
        this.handleCoordinatesChange(coordinates);
    }

    handleCoordinatesChange(position) {
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                latitude: position.lat,
                longitude: position.lng,
            },
            circleCenter: [position.lat, position.lng],
        }));
    }

    isNotEmptyTransportTypes() {
        return this.state.transportTypes && this.state.transportTypes.length !== 0;
    }
    mapRoute() {
        console.log('mapRoute');
        const route = [];
        const coordinates = this.state?.element?.coordinates;
        if (coordinates?.length > 1) {
            coordinates.sort((a, b) => a.position - b.position); // dla pewności
            for (let i = 1; i < coordinates.length; i++) {
                const prev = coordinates[i - 1];
                const curr = coordinates[i];
                const color = MapLibreUtils.getColorBySpeed(curr.speed);
    
                const segment = {
                    distance: curr.distance,
                    coordinates: [[prev.longitude, prev.latitude], [curr.longitude, curr.latitude ]],
                    averageSpeed: curr.speed,
                    durationInMinutes: (new Date(curr.date) - new Date(prev.date)) / 1000 ,
                    color: color
                };
                route.push(segment);
            }
        }
        this.setState((prevState) => ({
            ...prevState,
            route: route
                })
            );
    }


    getUserCleanSearchCriteria() {
        return {
            email: '',
            name: '',
            role: undefined,
            id: null,
            firstResult: 0,
            roles: [],
            maxResults: 5,
            sortField: 'id',
            sortAsc: true,
        };
    }
    getTransportCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            name: '',
            firstResult: 0,
            maxResults: 5,
            sortField: 'id',
            sortAsc: false,
        };
    }
    // TODO: to moze byc inside DatalLazy wywołane w useState tak by było lepiej ale poki co olac
    getUserList = (criteria) => {
        console.log('getUserList');
        this.mobileUserService
            .getDetailsList(criteria)
            .then((data) => {
                this.setState((prevState) => ({
                    ...prevState,
                    usersPageable: data,
                    loadDataUser: true,
                }));
            })
            .catch(() => {
                this.showErrorMessage(t('user-transport.user-list-failed'));
            });
    };
    getTransportList = (criteria) => {
        console.log('getTransportList');
        this.companyTransportService
            .getDetailsList(criteria)
            .then((data) => {
                this.setState((prevState) => ({
                    ...prevState,
                    transportPageable: data,
                    loadDataTransport: true,
                }));
            })
            .catch(() => {
                this.showErrorMessage(t('user-transport.transport-list-failed'));
            });
    };
    renderDetails() {
        console.log('[UserTransportContainer] renderDetails - element:', this.state.element);
        const {locale} = this.state;
        const colSpacing =
            this.viewMode() === 'NEW' || this.state.element.coordinates?.length === 0
                ? 'col-xl-12 col-lg-12 col-md-12 col-sm-12'
                : 'col-xl-6 col-lg-6 col-md-12 col-sm-12';
        return (
            <React.Fragment>
                <div className='row'>
                    {this.state.showConfirmExcludeTransport ? (
                        <YesNoDialog
                            onChange={(type, x, target) => {
                                if (target.value) {
                                    this.onExcludeAction(() => {
                                        this.setState({showConfirmExcludeTransport: false});
                                        this.showSuccessMessage(t('user-transport.exclude.success'));
                                        this.unblockUi();
                                    });
                                } else {
                                    this.setState({showConfirmExcludeTransport: false});
                                }
                            }}
                            visible={this.state.showConfirmExcludeTransport}
                            header={t('user-transport.exclude.header')}
                            name='visible'
                            noButtonLabel={t('global.noButtonLabel')}
                            yesButtonLabel={t('global.yesButtonLabel')}
                            onHide={() => {
                                this.setState({showConfirmExcludeTransport: false});
                            }}
                            yesButtonClassName='red-button'
                        >
                            {t('user-transport.exclude.message')}
                        </YesNoDialog>
                    ) : null}

                    {this.state.showConfirmIncludeTransport ? (
                    <YesNoDialog
                       onChange={(type, x, target) => {
                           if (target.value) {
                               this.onIncludeAction(() => {
                                   this.setState({ showConfirmIncludeTransport: false });
                                   this.showSuccessMessage(t('user-transport.include.success'));
                                   this.unblockUi();
                               });
                           } else {
                               this.setState({ showConfirmIncludeTransport: false });
                           }
                       }}
                       visible={this.state.showConfirmIncludeTransport}
                       header={t('user-transport.include.header')}
                       name='visible'
                       noButtonLabel={t('global.noButtonLabel')}
                       yesButtonLabel={t('global.yesButtonLabel')}
                       onHide={() => {
                           this.setState({ showConfirmIncludeTransport: false });
                       }}
                       yesButtonClassName='red-button'
                   >
                      <div className="text-muted" style={{lineHeight: '1.4' }}>
                         <p className="mb-1">{t('user-transport.include.message')}</p>
                            <p className="mb-1">{t('user-transport.include.message2')}</p>
                        </div>
                       <div className='mt-2'>
                           <div className='row col-12 align-items-center'>
                               <label className='col-auto text-muted'>{t('user-transport.includeDirection')}</label>
                               <div className='col'>
                                   <InputDropdownComponent
                                       showClear
                                       id='includeDirection'
                                       name='includeDirection'
                                       optionLabel='label'
                                       dataKey='value'
                                       validator={this.validator}
                                       validators='required'
                                       value={this.state.element.includeDirection}
                                       options={this.state.directions}
                                       colClass='col-xl-6 col-lg-6 col-md-6 col-sm-6'
                                       onChange={this.handleChange}
                                       viewMode={'EDIT'}
                                       enumMode={true}
                                   />
                               </div>
                           </div>
                       </div>
                   </YesNoDialog>
                    ) : null}
                       {this.state.showConfirmIRejectIncludeTransport ? (
                        <YesNoDialog
                            onChange={(type, x, target) => {
                                if (target.value) {
                                    this.onIncludeRejectAction(() => {
                                        this.setState({showConfirmIRejectIncludeTransport: false});
                                        this.showSuccessMessage(t('user-transport.include.reject.success'));
                                        this.unblockUi();
                                    });
                                } else {
                                    this.setState({showConfirmIRejectIncludeTransport: false});
                                }
                            }}
                            visible={this.state.showConfirmIRejectIncludeTransport}
                            header={t('user-transport.include.reject.header')}
                            name='visible'
                            noButtonLabel={t('global.noButtonLabel')}
                            yesButtonLabel={t('global.yesButtonLabel')}
                            onHide={() => {
                                this.setState({showConfirmIRejectIncludeTransport: false});
                            }}
                            yesButtonClassName='red-button'
                        >
                             <div className="text-muted" style={{lineHeight: '1.4' }}>
                             <p className="mb-1">
                                     {t('user-transport.include.reject.message')}
                            </p>
                            </div>
                            
                        </YesNoDialog>
                    ) : null}
                    <div className={colSpacing}>
                        <Panel header={t('user-transport.summary')}>
                            <div className='row'>
                            <InputTextComponent
                                id={`${locale}-name`}
                                name='name'
                                label={t('transport.name')}
                                colClass='col-xl-3 col-lg-3 col-md-4 col-sm-6'
                                value={this.state.element?.transport?.translations[locale]?.name}
                                validator={this.validator}
                                onChange={this.handleChange}
                                viewMode={'VIEW'}
                                rendered={this.viewMode() !== 'NEW'}
                            />
                              <InputTextComponent
                                id={`${locale}-device`}
                                name='device'
                                label={t('transport.device')}
                                colClass='col-xl-3 col-lg-3 col-md-4 col-sm-6'
                                value={StringUtils.isBlank(this.state.element?.device) ? 'AMANDA' : this.state.element?.device}
                                validator={this.validator}
                                onChange={this.handleChange}
                                viewMode={'VIEW'}
                                rendered={this.viewMode() !== 'NEW'}
                            />
                            {this.props.viewMode === 'VIEW' ? (
                                    <InputTextComponent
                                        id={`${locale}-successful`}
                                        name='successful'
                                        label={t('user-transport.successful')}
                                        colClass='col-xl-3 col-lg-3 col-md-4 col-sm-6'
                                        value={(this.state.element?.successful !== undefined && this.state.element?.successful !== null) || 
                                               (this.state.element?.successfull !== undefined && this.state.element?.successfull !== null)
                                            ? ((this.state.element.successful !== undefined ? this.state.element.successful : this.state.element.successfull) 
                                                ? t('global.yes') : t('global.no'))
                                            : ''}
                                        viewMode={'VIEW'}
                                        rendered={this.viewMode() !== 'NEW'}
                                    />
                                ) : null}
                            </div>
                            <div className='row'>
                                {this.props.viewMode === 'VIEW' ? (
                                    <InputTextComponent
                                        id={`${locale}-direction`}
                                        name='direction'
                                        label={t('user-transport.direction')}
                                        colClass='col-xl-3 col-lg-3 col-md-4 col-sm-6'
                                        value={this.state.element.direction === null ? '' : t(`direction.${this.state.element?.direction}`)}
                                        viewMode={'VIEW'}
                                    />
                                ) : (
                                    <InputDropdownComponent
                                        showClear
                                        id='direction'
                                        name='direction'
                                        label={t('user-transport.direction')}
                                        optionLabel='label'
                                        dataKey='enumValue'
                                        validator={this.validator}
                                        validators='required'
                                        value={
                                            StringUtils.isBlank(this.state.element.direction)
                                                ? this.state.directions[2].value
                                                : this.state.element.direction
                                        }
                                        options={this.state.directions}
                                        colClass='col-xl-3 col-lg-3 col-md-4 col-sm-6'
                                        onChange={this.handleChange}
                                        viewMode={this.props.viewMode}
                                        enumMode={true}
                                    />
                                )}
                                <InputCalendarRangeComponent
                                    key={'dates'}
                                    idFrom={'startTravelDate'}
                                    idTo={'finishTravelDate'}
                                    nameTo={'finishTravelDate'}
                                    nameFrom={'startTravelDate'}
                                    label={''}
                                    labelFrom={t('user-transport.startDate')}
                                    labelTo={t('user-transport.endDate')}
                                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                                    from={this.state.element.startTravelDate}
                                    to={this.state.element.finishTravelDate}
                                    validator={[this.validator, this.validatorDraft]}
                                    onChange={this.handleChange}
                                    viewMode={this.viewMode()}
                                    maxDate={DateUtils.endOfToday()}
                                    showTime
                                    showIcon
                                    validatorsTo={`required|date|after_or_equal_datetime~${moment(
                                        this.state.element.startTravelDate ? this.state.element.finishTravelDate : new Date()
                                    )
                                        .format('DD-MM-YYYY HH:mm')
                                        .toString()}`}
                                    placeholderFrom='dd-mm-rrrr GG:MM'
                                    placeholderTo='dd-mm-rrrr GG:MM'
                                    validateViewMode
                                    dateFormatMoment='DD-MM-YYYY HH:mm'
                                    validatorsToType='after_or_equal_datetime'
                                    onAfterStateChange={() => {
                                        this.calculateAverageSpeed(() => {
                                            this.calculateBurnedCalories();
                                        });
                                    }}
                                />
                                <InputNumberComponent
                                    id={`${locale}-totalDistanceTraveledKilometer`}
                                    name='totalDistanceTraveledKilometer'
                                    label={t('user-transport.traveled')}
                                    validator={this.validator}
                                    colClass='col-xl-3 col-lg-3 col-md-4 col-sm-6'
                                    value={this.state.element?.totalDistanceTraveledKilometer}
                                    onChange={this.handleChange}
                                    mode='decimal'
                                    minFractionDigits={0}
                                    maxFractionDigits={2}
                                    viewMode={this.viewMode()}
                                    onAfterStateChange={() => {
                                        this.calculateAverageSpeed(() => {
                                            this.calculateBurnedCalories();
                                        });
                                        this.calculateSavedCo2();
                                        this.calculateTotalCoins();
                                    }}
                                />
                                <InputNumberComponent
                                    id={`${locale}-durationInMinutes`}
                                    name='durationInMinutes'
                                    label={t('user-transport.duration')}
                                    colClass='col-xl-3 col-lg-3 col-md-4 col-sm-6'
                                    validator={this.validator}
                                    value={this.state.element?.durationInMinutes}
                                    onChange={this.handleChange}
                                    mode='decimal'
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    viewMode={this.viewMode()}
                                    disabled={true}
                                    rendered={this.viewMode() !== 'NEW'}
                                />
                                {' '}
                                <InputNumberComponent
                                    id={`${locale}-totalEarnedCoins`}
                                    name='totalEarnedCoins'
                                    label={t('user-transport.points')}
                                    colClass='col-xl-3 col-lg-3 col-md-4 col-sm-6'
                                    validator={this.validator}
                                    onChange={this.canModifyTransportRewards() ? this.handleChange : undefined}
                                    value={this.state.element?.totalEarnedCoins}
                                    viewMode={this.getRewardsFieldViewMode()}
                                    disabled={!this.canModifyTransportRewards()}
                                    mode='decimal'
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    min={0}
                                />
                                <InputNumberComponent
                                    id={`${locale}-averageSpeed`}
                                    name='averageSpeed'
                                    label={t('user-transport.speed')}
                                    colClass='col-xl-3 col-lg-3 col-md-3 col-sm-6'
                                    value={this.state.element?.averageSpeed}
                                    validator={this.validator}
                                    mode='decimal'
                                    minFractionDigits={0}
                                    maxFractionDigits={2}
                                    onChange={this.handleChange}
                                    viewMode={this.viewMode()}
                                    disabled={true}
                                />
                                <InputNumberComponent
                                    id={`${locale}-savedCo2Gram`}
                                    name='savedCo2Gram'
                                    validator={this.validator}
                                    label={
                                        <span>
                                            {t('user-transport.saved')} CO<sub>2</sub> (g)
                                        </span>
                                    }
                                    onChange={this.canModifyTransportRewards() ? this.handleChange : undefined}
                                    mode='decimal'
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    min={0}
                                    colClass='col-xl-3 col-lg-3 col-md-4 col-sm-6'
                                    value={this.state.element?.savedCo2Gram}
                                    viewMode={this.getRewardsFieldViewMode()}
                                    disabled={!this.canModifyTransportRewards()}
                                />
                                <InputNumberComponent
                                    id={`${locale}-burnedCalories`}
                                    name='burnedCalories'
                                    validator={this.validator}
                                    label={t('user-transport.calories')}
                                    mode='decimal'
                                    minFractionDigits={0}
                                    maxFractionDigits={2}
                                    onChange={this.handleChange}
                                    colClass='col-xl-3 col-lg-3 col-md-4 col-sm-6'
                                    value={this.state.element?.burnedCalories}
                                    viewMode={this.viewMode()}
                                    disabled={true}
                                />
                            </div>
                            <div className='mt-4 mb-4'></div>
                            {this.state.element?.carSharingDriver ? (
                                <div className='row mt-2'>
                                    <div className='col-12'>
                                        <div className='d-flex align-items-center justify-content-between mb-2'>
                                            <label className='font-weight-bold mb-0'>Pasażerowie</label>
                                            <span
                                                style={{
                                                    backgroundColor: '#eef4ff',
                                                    color: '#2f5597',
                                                    borderRadius: '999px',
                                                    padding: '2px 10px',
                                                    fontSize: '0.85rem',
                                                    fontWeight: 600,
                                                }}
                                            >
                                                {(this.state.element?.passengers ?? []).length}
                                            </span>
                                        </div>

                                        {(this.state.element?.passengers ?? []).length === 0 ? (
                                            <div
                                                style={{
                                                    border: '1px dashed #ced4da',
                                                    borderRadius: '10px',
                                                    padding: '10px 12px',
                                                    color: '#6c757d',
                                                }}
                                            >
                                                Brak pasażerów w tym przejeździe
                                            </div>
                                        ) : (
                                            <div className='d-flex flex-column' style={{gap: '8px'}}>
                                                {this.state.element.passengers.map((passenger) => {
                                                    const avatarPath = this.getPassengerAvatarPath(passenger?.avatarUuid);
                                                    return (
                                                        <div
                                                            key={passenger.id}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                border: '1px solid #e9ecef',
                                                                borderRadius: '10px',
                                                                padding: '8px 10px',
                                                                backgroundColor: '#fff',
                                                            }}
                                                        >
                                                            <div style={{display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0}}>
                                                                {avatarPath ? (
                                                                    <img
                                                                        src={avatarPath}
                                                                        alt='Avatar pasażera'
                                                                        style={{
                                                                            width: '30px',
                                                                            height: '30px',
                                                                            borderRadius: '50%',
                                                                            objectFit: 'cover',
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <div
                                                                        style={{
                                                                            width: '30px',
                                                                            height: '30px',
                                                                            borderRadius: '50%',
                                                                            backgroundColor: '#e9ecef',
                                                                            color: '#495057',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 700,
                                                                            flexShrink: 0,
                                                                        }}
                                                                    >
                                                                        {this.getPassengerInitials(passenger?.fullName)}
                                                                    </div>
                                                                )}
                                                                <span
                                                                    style={{
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                    }}
                                                                >
                                                                    {passenger?.fullName}
                                                                </span>
                                                            </div>
                                                            <i className='mdi mdi-seat-passenger' style={{color: '#6c757d'}} />
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : null}
                        </Panel>
                        <Panel header={t('user-transport.user-selected')} className='mt-2'>
                            {this.props.viewMode !== 'NEW' ? (
                                <div className='row'>
                                    <InputTextComponent
                                        id={`${locale}-name`}
                                        name='user'
                                        label={t('user-transport.nick')}
                                        colClass='col-xl-4 col-lg-6 col-md-12 col-sm-12'
                                        value={this.state.element?.user?.name}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id={`${locale}-firstName`}
                                        name={t('user.firstName')}
                                        label={'Imię'}
                                        colClass='col-xl-4 col-lg-6 col-md-12 col-sm-12'
                                        value={this.state.element?.user?.firstName}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id={`${locale}-lastName`}
                                        name='lastName'
                                        label={t('user.lastName')}
                                        colClass='col-xl-4 col-lg-6 col-md-12 col-sm-12'
                                        value={this.state.element?.user?.lastName}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={'VIEW'}
                                    />{' '}
                                    <InputTextComponent
                                        id={`${locale}-email`}
                                        name='email'
                                        label={t('user.email')}
                                        colClass='col-xl-6 col-lg-12 col-md-12 col-sm-12'
                                        value={this.state.element?.user?.email}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={'VIEW'}
                                    />
                                </div>
                            ) : (
                                <div className='row'>
                                    {this.state?.loadDataUser && (
                                        <div className='col-8'>
                                            <DataTableLazy
                                                id='user-table'
                                                className="custom-datatable"
                                                dataPageable={this.state.usersPageable}
                                                rendered={true}
                                                selectionMode={'radiobutton'}
                                                rows={5}
                                                loadLazyData={(criteria) => this.mobileUserService.getDetailsList(criteria)}
                                                onSelect={(val) => {
                                                    this.setState(
                                                        (prevState) => ({
                                                            element: {
                                                                ...prevState.element,
                                                                user: val,
                                                            },
                                                        }),
                                                        () => {
                                                            this.calculateAverageSpeed(() => {
                                                                this.calculateBurnedCalories();
                                                            });
                                                            this.calculateSavedCo2();
                                                            this.calculateTotalCoins();
                                                        }
                                                    );
                                                }}
                                                rowsPerPageOptions={[]}
                                                initialCriteria={this.getUserCleanSearchCriteria()}
                                                columns={[
                                                    {
                                                        field: 'name',
                                                        header: t('user-transport.fullName'),
                                                        filter: true,
                                                        body: (row) => {
                                                            const firstName = row.firstName ? row.firstName : '';
                                                            const lastName = row.lastName ? row.lastName : '';
                                                            return firstName + ' ' + lastName;
                                                        },
                                                    },
                                                    {field: 'email', header: t('user.email'), filter: true},
                                                ]}
                                            />
                                        </div>
                                    )}
                                    {this.state?.loadDataTransport && (
                                        <div className='col-4'>
                                            <DataTableLazy
                                                className="custom-datatable" 
                                                ref={this.transportsTable}
                                                id='transport-table'
                                                rendered={true}
                                                dataPageable={this.state?.transportPageable}
                                                rows={5}
                                                selectionMode={'radiobutton'}
                                                loadLazyData={(criteria) => this.companyTransportService.getDetailsList(criteria)}
                                                onSelect={(val) => {
                                                    const transport = val;
                                                    if (!StringUtils.isBlank(transport)) {
                                                        const translations = [];
                                                        translations.push([{pl: {name: transport?.name}}]);
                                                        transport.translations = translations;
                                                    }
                                                    this.setState(
                                                        (prevState) => ({
                                                            element: {
                                                                ...prevState.element,
                                                                transport: transport,
                                                            },
                                                        }),
                                                        () => {
                                                            this.calculateAverageSpeed(() => {
                                                                this.calculateBurnedCalories();
                                                            });
                                                            this.calculateSavedCo2();
                                                            this.calculateTotalCoins();
                                                        }
                                                    );
                                                }}
                                                rowsPerPageOptions={[]}
                                                initialCriteria={this.getTransportCleanSearchCriteria()}
                                                columns={[{field: 'name', header: t('user-transport.activity-name'), filter: true}]}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </Panel>
                    </div>
                    {this.viewMode() !== 'NEW' && (
                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                            {this.state.route?.length > 0 && (
                                <MapWithRouteV2
                                    distance={this.state.element.totalDistanceTraveledKilometer}
                                    averageSpeed={this.state.element.averageSpeed}
                                    position
                                    route={this.state.route}
                                    companyLocations={this.state.element?.companyLocations ?? []}
                                />
                            )}
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

UserTransportContainer.defaultProps = {
    backUrl: '/user-transport-list',
    editUrl: '/user-transport/edit',
    detailUrl: '/user-transport/details',
    lazy: true,
};

UserTransportContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
    detailUrl: PropTypes.string,
};

export default withRouter(withTranslation()(UserTransportContainer));
